/* eslint-disable i18next/no-literal-string */
import { styled } from "@mui/material/styles"
import Typography from "@mui/material/Typography"
import Icon from "Components/Icon/Icon"
import ContentImage from "Components/Image/ContentImage"
import { IImage } from "data/contentData/interfaces/mongodb/IImage"
import { t } from "translations"

export default function MicrositeHeader({
    logo,
    title
}: {
    logo: IImage
    title: string
}) {
    return (<StyledDiv>
        {logo && (
            <LogoWrapper>
                <StyledLogo image={logo} />
            </LogoWrapper>)}
        <ArticleTemplateNameContainer>
            <ArticleTemplateName
                variant="subtitle2"
                color="inherit">
                <Icon
                    name="articleOutlined"
                    fontSize="small"
                />
                {t.relatedContentMarketing} - Mikroside for {title}
            </ArticleTemplateName>
        </ArticleTemplateNameContainer>
    </StyledDiv>)
}

const StyledDiv = styled("div")(({ theme }) => ({
    marginTop: `-${theme.spacing(2)}`,
    marginBottom: theme.spacing(2)
}))

const LogoWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    paddingRight: theme.spacing(2),
    height: "28px",
    [theme.breakpoints.up("md")]: {
        paddingRight: theme.spacing(0),
        marginTop: theme.spacing(0)
    }
}))

const StyledLogo = styled(ContentImage)(() => ({
    width: "auto",
    height: "100%"
}))

const ArticleTemplateName = styled(Typography)(({ theme }) => ({
    fontSize: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1)
}))

const ArticleTemplateNameContainer = styled("div")(({ theme }) => ({
    color: theme.palette.common.white,
    backgroundColor: theme.palette.advertiser.main,
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(1, 2, 1, 2),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
        padding: theme.spacing(2, 0, 2, 4),
        gap: theme.spacing(2)
    }
}))